export function obterListaStatusPagamento() {
  return (
    [
      { label: 'Selecione...', value: '' },
      { label: 'Aprovado', value: 'Aprovado' },
    ]
  );
}
